import React, { useEffect, useState } from 'react'
import style from '../../../css/dashboard/landing_dash/DashboardLanding.module.css'
import { useNavigate } from 'react-router-dom';

import { Chart } from 'chart.js';

const DashboardLanding = () => {

    const [fullName, setFullName] = useState('');

    useEffect(() => {
        // Retrieve the stored user name from localStorage
        const storedFullName = localStorage.getItem('fullName');

        if (storedFullName) {
            setFullName(storedFullName);
        }
    }, []);

    // Adjust scroll position to account for fixed navbar

    const navigate = useNavigate();

    const scrollToSection = (sectionId) => {
        setTimeout(() => {
            const section = document.getElementById(sectionId);
            if (section) {
                window.scrollTo({
                    top: section.offsetTop - 150,  // Adjust the offset to match your navbar height
                    behavior: 'smooth',
                });
            }
        }, 10);
    };

    const scrolltocourses = (e) => {
        e.preventDefault();
        navigate('/');
        scrollToSection('coursesbuyy');

    };



    return (
        <>

            <div className="container-fluid p-3 my-3">
                <div className="row" >
                    <div className="col-md-8">
                    </div>
                    <h1>STOCKEXPLODER</h1>
                    <div className="col-md-4">
                    </div>
                </div>
            </div>


        </>
    )
}

export default DashboardLanding